import { flatMap } from 'lodash-es';
import { type ticketDetails, providerClassLib } from 'shared';

import { convertBaggage } from '../convert-baggage';
import { countConnections, countStops, isDirectFlight } from '../offer';

/**
 * Парсит данные оффера для аналитики
 */
export const extractOfferData = (offer: ticketDetails.types.MappedOffer) => {
  const departure = offer.flights[0].segments[0].dep;
  const arrivalCity =
    offer.flights[0].segments[offer.flights[0].segments.length - 1]?.arr;
  const lastFlight = offer.flights[offer.flights.length - 1];
  const lastArrival = lastFlight.segments[lastFlight.segments.length - 1]?.arr;

  const airlines = offer.flights.flatMap(f =>
    f.segments.map(s => {
      return {
        iata: s.display_airline,
        title: s.airlineTitle,
      };
    }),
  );

  const baggage = offer.flights.flatMap(f =>
    f.segments.map(s => convertBaggage(s.baggage)),
  );

  const handLuggage = offer.flights.flatMap(f =>
    f.segments.map(s => convertBaggage(s.hand_luggage)),
  );

  const connections = countConnections(offer);
  const stops = countStops(offer);
  const isDirect = isDirectFlight(offer);
  const hasConnections = connections > 0;
  const hasStops = stops > 0;

  const isRefundable = Boolean(offer.features?.refundable?.value);
  const isExchangeable = Boolean(offer.features?.exchangeable?.value);
  const isCharter = providerClassLib.isFunSun(offer.$meta?.provider_class);

  const price = Number(offer.price.amount);

  const flightsNumbers = flatMap(offer.flights, f => {
    return f.segments.map(s => s.flight_number);
  });

  return {
    departure,
    arrivalCity,
    lastArrival,
    airlines,
    baggage,
    handLuggage,
    countConnections: connections,
    countStops: stops,
    isDirect,
    hasConnections,
    hasStops,
    isRefundable,
    isExchangeable,
    isCharter,
    price,
    flightsNumbers,
  };
};
